'use strict';

var getPropValue = function (baseObject, path) {
    return path.split('.').reduce(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (obj, prop) { return (obj === undefined ? obj : obj[prop]); }, baseObject);
};
var getThemeProp = function (attribute, defaultValue) {
    if (defaultValue === void 0) { defaultValue = ''; }
    return function (props) {
        return getPropValue(props.theme, attribute) || defaultValue;
    };
};

module.exports = getThemeProp;
